import { Navigate, useRoutes } from 'react-router-dom'
import DashboardLayout from '../layout/DashboardLayout'
import { DashBoardPage, EventPage, OrganizersPage } from '../screens/app'
import Callback from '../screens/app/callback'
import CreateEvent from '../screens/app/events/CreateEvent'
import SelectEvent from '../screens/app/events/SelectEvent'
import MacGuide from '../screens/app/desktop-guide/MacGuide'

export default function AdminRouting() {
  return useRoutes([
    {
      path: "/app",
      element : <DashboardLayout />,
      children : [
        {path: "dashboard", element : <DashBoardPage />},
        {path: "events/create", element : <CreateEvent />},
        {path: "events/select", element : <SelectEvent />},
        {path: "events/:page?/:id?/:tab?", element : <EventPage />},
        {path: "organizers", element : <OrganizersPage />},
        { path: "callback", element: <Callback /> },
        { path: "desktop-guide/mac", element: <MacGuide /> },
        { path: "", element : <Navigate to="/app/dashboard" replace /> },
        { path: "*", element : <Navigate to="/app/dashboard" replace /> }
      ]
    },
    {path: '' , element : <Navigate to="/app/dashboard" replace /> },
    {path: '*' , element : <Navigate to="/app/dashboard" replace /> }
  ])
}
